<template>
    <div
        v-if="levelItem"
        :class="itemClass"
    >
        <div
            v-debounce="handleClickStartGame"
            :class="itemContentClass"
        >
            <div
                v-if="levelItem.status === levelStatus.finished"
                class="level-score"
                :class="`level-score-${levelItem.score}`"
            ></div>
            <div
                v-else-if="levelItem.status === levelStatus.open"
                class="user-water"
            >
                <span class="avatar" :style="avatarStyle"></span>
            </div>
            <div class="level-num" :class="`level-num-${currentLevelTextArr.length}`">
                <num-img
                    v-for="(item, index) in currentLevelTextArr"
                    :key="index"
                    :class="`num-${index}`"
                    :number-text="item"
                    :number-color="'italic'"
                />
            </div>
        </div>
        <div :class="buildingClass"></div>
    </div>
</template>

<script>
import EventBus from '../../../constant/EventBus';
import {mapState, mapActions} from 'vuex';
import Const from '@/pages/pano-game/constant/Constant';
import {jumpByOpenapi} from '@/pages/pano-game/constant/JumpFunc';
import StatisticConst from '@/pages/pano-game/constant/StatisticConst';
import NumImg from '@/pages/pano-game/components/NumImg';

export default {
    data() {
        return {
            levelTypes: Const.levelTypes,
            levelStatus: Const.levelStatus
        };
    },
    props: {
        levelItem: {
            type: Object,
            default: () => {}
        },
        levelIndex: {
            type: Number,
            default: 0
        },
        headPortrait: {
            type: String,
            default: Const.defaultAvatar
        }
    },
    components: {
        NumImg
    },
    computed: {
        ...mapState([
            'urlParams',
            'isNative',
            'ordinaryCoin'
        ]),
        ...mapState('kingRoad', [
            'kingRoadData',
            'myCoin',
            'staminaNum',
            'staminaNumT',
            'kingRoadNum',
            'preShowNum',
            'medalNum',
            'isContinue',
            'continueType',
            'isNewPeople',
            'breakLevel',
            'playMaxLevel',
            'levelList',
            'kingRoadCostCoin'
        ]),
        // 当前关卡
        currentLevel() {
            return this.levelIndex + 1;
        },
        currentLevelTextArr() {
            return String(this.currentLevel).split('');
        },
        unlocked() {
            return this.levelItem
                && (this.levelItem.status === this.levelStatus.finished
                    || this.levelItem.status === this.levelStatus.open);
        },
        avatarStyle() {
            const style = {};
            style.backgroundImage = `url(${this.headPortrait})`;
            return style;
        },
        // 关卡样式集合
        itemClass() {
            const levelClass = ['level-item-wrapper'];
            levelClass.push(`loc-${this.levelIndex % 4}`);
            levelClass.push(`level-${this.levelIndex + 1}`);
            // 判断是非空关卡
            if (this.levelItem.level) {
                levelClass.push(`level-ts-${this.levelItem.level_type}-${this.levelItem.status}`);
            }
            return levelClass;
        },
        itemContentClass() {
            const levelContentClass = ['level-item-content'];
            // 判断是非空关卡
            if (this.levelItem.level) {
                levelContentClass.push(`level-ts-${this.levelItem.level_type}-${this.levelItem.status}`);
            }
            return levelContentClass;
        },
        // 建筑物样式,10关之后，8个循环一次，奇数关卡附加建筑物
        buildingClass() {
            const baseClass = ['building'];
            const startNum = 10;
            // 计算需要建筑物的关卡
            let num = this.currentLevel > startNum ? (this.currentLevel - startNum) % 8 + 1 : 0;
            if (num > 0 && (num - 1) % 2 === 1) {
                num = Math.floor((num - 1) / 2) + 1;
            }
            else {
                num = 'none';
            }
            baseClass.push(`building-${num}`);
            return baseClass;
        }
    },
    mounted() {
        EventBus.$on('answerItemReset', () => {
            this.status = 0;
            this.isCheckout = 0;
            // this.isCanClick = true;
            this.$emit('handleCanClick', true);
        });
    },
    methods: {
        ...mapActions('pano', [
            'quitGame'
        ]),
        // 开始闯关
        handleClickStartGame() {
            // 判断关卡是否解锁
            if (!this.levelItem.level) {
                this.$toast('当前关卡还未开放，敬请期待！');
            }
            // 判断关卡是否解锁
            else if (!this.unlocked) {
                this.$toast('当前关卡还未解锁哦！');
            }
            // 端外需要先回到端内
            else if (!this.isNative) {
                jumpByOpenapi(location.origin + location.pathname);
            }
            // 判断是否有中断题目,且类型为闯关模式
            else if (
                this.isContinue === Const.continue.yes
                && this.continueType === Const.gameMode.kingRoad
            ) {
                this.$parent.openDialog(Const.mainDialogNum.notFinish);
            }
            // 判断体力大于0，继续逻辑
            else if (this.staminaNum > 0) {
                // todo 中断类型不匹配，需要前端清理答题缓存，之后需要服务端优化缓存配置
                if (this.isContinue === Const.continue.yes) {
                    this.quitGame({type: this.continueType})
                        .then(() => {
                            this.jumpKingRoadGame();
                        })
                        .catch(e => {
                            this.$toast(e.message || '服务异常请稍后再试');
                        });
                }
                else {
                    this.jumpKingRoadGame();
                }
            }
            // 判断金币使用策略
            else if (this.myCoin >= this.kingRoadCostCoin) {
                this.$parent.openDialog(Const.mainDialogNum.useCoin, this.levelIndex + 1);
            }
            else {
                this.$toast('金币不足');
            }

        },
        // 进入游戏
        jumpKingRoadGame() {
            const url  = location.origin + location.pathname
                + `#/pano?type=${Const.gameMode.kingRoad}`
                + `&level=${this.currentLevel}&fr=${this.urlParams.fr || ''}`;
            jumpByOpenapi(url);
            this.$emit('judgePlatBury');
        }
    }
};
</script>
<style lang='scss'>
.level-item-wrapper {
    display: block;
    position: relative;
    width: 100%;
    height: 76px;
    .level-item-content {
        display: block;
        position: absolute;
        width: 58px;
        height: 47px;
        background-size: 51px 39px;
        background-position: center bottom;
        background-repeat: no-repeat;
        background-image: url(../../../assets/v4/kingRoad/nomal-off.png);
        .level-num {
            color: #fff;
            font-size: 12px;
            font-family: PingFang-SC-Blod;
            font-weight: bolder;
            position: absolute;
            left: 38px;
            top: 23px;
            // 1～9样式
            &.level-num-1 {}
            // 10～99样式
            &.level-num-2 {
                left: 34px;
                top: 24px;
                .num-0 {}
                .num-1 {
                    position: relative;
                    left: 1px;
                    top: -2px;
                }
            }
            // 100～999样式
            &.level-num-3 {
                left: 31px;
                top: 25px;
                .num-1 {
                    position: relative;
                    left: 1px;
                    top: -2px;
                }
                .num-2 {
                    position: relative;
                    left: 2px;
                    top: -4px;
                }
            }
        }
        // 星级
        .level-score {
            width: 45px;
            height: 18px;
            position: absolute;
            left: 8px;
            top: -9px;
            background-size: cover;
            background-repeat: no-repeat;
            pointer-events: none;
            &.level-score-1 {
                background-image: url(../../../assets/v4/kingRoad/star1.png);
            }
            &.level-score-2 {
                background-image: url(../../../assets/v4/kingRoad/star2.png);
            }
            &.level-score-3 {
                background-image: url(../../../assets/v4/kingRoad/star3.png);
            }
        }
        .user-water {
            position: absolute;
            left: 6px;
            bottom: 26px;
            z-index: 8;
            width: 48px;
            height: 62px;
            background-size: cover;
            background-repeat: no-repeat;
            background-image: url(../../../assets/v4/kingRoad/avatar-bg.png);
            .avatar {
                position: absolute;
                left: 6px;
                top: 6px;
                width: 37px;
                height: 37px;
                background-size: cover;
                background-repeat: no-repeat;
                border-radius: 50%;
            }
        }
        // 简单关卡-已完成
        // 简单关卡-已解锁
        &.level-ts-0-0,
        &.level-ts-0-1 {
            background-image: url(../../../assets/v4/kingRoad/nomal-on.png);
        }
        // 简单关卡-未解锁
        &.level-ts-0-2 {
            background-image: url(../../../assets/v4/kingRoad/nomal-off.png);
            .level-num {
                left: 38px;
                top: 22px;
                &.level-num-2 {
                    left: 34px;
                    top: 23px;
                }
                &.level-num-3 {
                    left: 30px;
                    top: 24px;
                }
            }
        }
        // 困难关卡-已完成
        // 困难关卡-已解锁
        &.level-ts-1-0,
        &.level-ts-1-1{
            background-size: 58px 47px;
            background-image: url(../../../assets/v4/kingRoad/spec-on.png);
            .level-score {
                left: 7px;
                top: -14px;
            }
            .user-water {
                left: 5px;
                bottom: 36px;
            }
            .level-num {
                left: 38px;
                top: 17px;
                &.level-num-2 {
                    left: 34px;
                    top: 18px;
                }
                &.level-num-3 {
                    left: 30px;
                    top: 19px;
                }
            }
        }
        // 困难关卡-未解锁
        &.level-ts-1-2 {
            background-size: 58px 47px;
            background-image: url(../../../assets/v4/kingRoad/spec-off.png);
            .level-num {
                left: 38px;
                top: 16px;
                &.level-num-2 {
                    left: 34px;
                    top: 17px;
                }
                &.level-num-3 {
                    left: 30px;
                    top: 19px;
                }
            }
        }
    }
    .building {
        position: absolute;
        background-size: cover;
        background-repeat: no-repeat;
        pointer-events: none;
        &.building-none {
            display: none;
        }
        &.building-1 {
            left: 0;
            bottom: 2px;
            width: 187px;
            height: 320px;
            background-image: url(../../../assets/v4/kingRoad/3-l-pool.png);
        }
        &.building-2 {
            right: 0;
            bottom: 20px;
            width: 184px;
            height: 289px;
            background-image: url(../../../assets/v4/kingRoad/4-r-hotel.png);
        }
        &.building-3 {
            left: 0;
            bottom: 40px;
            width: 168px;
            height: 206px;
            background-image: url(../../../assets/v4/kingRoad/1-l-car.png);
        }
        &.building-4 {
            right: 0;
            bottom: -24px;
            width: 185px;
            height: 365px;
            background-image: url(../../../assets/v4/kingRoad/2-r-school.png);
        }
    }
    &.loc-0 {
        .level-item-content {
            bottom: 10px;
            left: 200px;
        }
    }
    &.loc-1 {
        .level-item-content {
            bottom: 4px;
            left: 110px;
        }
    }
    &.loc-2 {
        .level-item-content {
            bottom: 15px;
            left: 125px;
        }
    }
    &.loc-3 {
        .level-item-content {
            bottom: 0;
            left: 195px;
        }
    }
    &.level-1 {
        height: 90px;
        .level-item-content {
            bottom: 53px;
            left: 215px;
        }
        .building-none {
            display: block;
            right: 0;
            bottom: 66px;
            width: 184px;
            height: 289px;
            background-image: url(../../../assets/v4/kingRoad/4-r-hotel.png);
        }
    }
    &.level-2 {
        height: 48px;
        .level-item-content {
            bottom: 0;
            left: 140px;
        }
    }
    &.level-3 {
        height: 80px;
        .level-item-content {
            bottom: 35px;
            left: 105px;
        }
        .building-none {
            display: block;
            left: 0;
            bottom: 55px;
            width: 187px;
            height: 320px;
            background-image: url(../../../assets/v4/kingRoad/3-l-pool.png);
        }
    }
    &.level-4 {
        height: 80px;
        .level-item-content {
            bottom: 16px;
            left: 165px;
        }
    }
    &.level-5 {
        height: 80px;
        .level-item-content {
            bottom: 20px;
            left: 210px;
        }
        .building-none {
            display: block;
            right: 0;
            bottom: 9px;
            width: 185px;
            height: 365px;
            background-image: url(../../../assets/v4/kingRoad/2-r-school.png);
        }
    }
    &.level-6 {
        height: 80px;
        .level-item-content {
            bottom: 18px;
            left: 130px;
        }
    }
    &.level-7 {
        height: 80px;
        .level-item-content {
            bottom: 20px;
            left: 117px;
        }
        .building-none {
            display: block;
            left: 0;
            bottom: 60px;
            width: 168px;
            height: 206px;
            background-image: url(../../../assets/v4/kingRoad/1-l-car.png);
        }
    }
    &.level-8 {
        height: 80px;
        .level-item-content {
            bottom: 10px;
            left: 188px;
        }
    }
    &.level-9 {
        .level-item-content {
            bottom: 25px;
            left: 183px;
        }
        .building-none {
            display: block;
            right: -20px;
            bottom: 32px;
            width: 188px;
            height: 199px;
            background-image: url(../../../assets/v4/kingRoad/5-r-poll.png);
        }
    }
    &.level-10 {
        .level-item-content {
            bottom: 3px;
            left: 110px;
        }
    }
}
</style>